import { render, staticRenderFns } from "./LoyaltyList.vue?vue&type=template&id=ec526c62&scoped=true"
import script from "./LoyaltyList.vue?vue&type=script&lang=ts"
export * from "./LoyaltyList.vue?vue&type=script&lang=ts"
import style0 from "./LoyaltyList.vue?vue&type=style&index=0&id=ec526c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec526c62",
  null
  
)

export default component.exports